const SkillsData = [
  {
    name: "Python",
    image: require("../assets/Images/python.png"),
  },
  {
    name: "C++",
    image: require("../assets/Images/cpp.png"),
  },

   {
    name: "Machine Learning",
    image: require("../assets/Images/ml.png"),
  },  
   {
    name: "Pandas",
    image: require("../assets/Images/pandas.png"),
  },
  {
    name: "NumPy",
    image: require("../assets/Images/numpy.png"),
  },
  {
    name: "Seaborn",
    image: require("../assets/Images/seaborn.png"),
  },
  {
    name: "Matplotlib",
    image: require("../assets/Images/matplotlib.png"),
  },

  {
    name: "NLP",
    image: require("../assets/Images/nlp.png"),
  },
  {
    name: "Deep Learning",
    image: require("../assets/Images/dl.png"),
  },

  {
    name: "LangChain",
    image: require("../assets/Images/langchain.png"),
  },

  {
    name: "Agentic Ai",
    image: require("../assets/Images/ai-agent.png"),
  },
   {
    name: "TensorFlow",
    image: require("../assets/Images/tensorflow.png"),
  },


 {
    name: "Power Bi",
    image: require("../assets/Images/power-bi.png"),
  },
   {
    name: "Tableau",
    image: require("../assets/Images/tableau.png"),
  },
   {
    name: "SQL (MySQL)",
    image: require("../assets/Images/mysql.png"),
  },

    {
    name: "HTML/CSS",
    image: require("../assets/Images/html-css.png"),
  },
  {
    name: "Bootstrap",
    image: require("../assets/Images/Bootstrap.png"),
  },
     {
    name: "Tailwind CSS",
    image: require("../assets/Images/Tailwind-CSS.png"),
  },
  {
    name: "JavaScript",
    image: require("../assets/Images/javascript.png"),
  },
  {
    name: "React.js",
    image: require("../assets/Images/react.png"),
  },
    {
    name: "Azure AI",
    image: require("../assets/Images/azure.png"),  
  },
  {
    name: "Docker",
    image: require("../assets/Images/docker.png"), 
  },
  {
    name: "Git/GitHub",
    image: require("../assets/Images/github.png"), 
  },
 
  {
    name: "Problem Solving",
    image: require("../assets/Images/dsa.png"), 
  },
   {
    name: "OOP",
    image: require("../assets/Images/oop.png"), 
  },
];

export default SkillsData;